import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AbstractHttpService } from '../auth/http-abstract-service';
import { MediaTypeEnum, ProductDto, ResponseDto, SdkCategoryDto, SdkDto, SdkVendorDto, UserDto } from '../../dto';


@Injectable({
	providedIn: 'root'
})
export class HttpSdkService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/sdk');
	}

	saveSdk(input: SdkDto): Observable<ResponseDto> {
		return super.post(`/save`, input);
	}
	getSdkCategories(): Observable<SdkCategoryDto[]> {
		return super.get(`/get-categories`);
	}
	getSdkVendors(): Observable<SdkVendorDto[]> {
		return super.get(`/get-vendors`);
	}
	getAllSdks(input: SdkDto): Observable<SdkDto[]> {
		return super.post(`/get-all`, input);
	}
	getSdkById(input: number): Observable<SdkDto> {
		return super.get(`/${input}/get-by-id`);
	}
	sdkAction(input: SdkDto, type: 'enable' | 'disable' | 'delete'): Observable<ResponseDto> {
		switch (type) {
			case 'enable':
				return super.post(`/enable`, input);
			case 'disable':
				return super.post(`/disable`, input);
			case 'delete':
				return super.post(`/delete`, input);
			default:
				return of({success: false, error: 'Invalid action'});
		}
		
	}
}
